import React from 'react';
import urlBase from '../../url-base';

import axios from 'axios';



class PlansNew extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      listOfStates:[],
      modalPlansClinico: false,
      modalPlansClinicoSLZ: false,
      modalPlansDigital: false,
      modalPlansVip: false,
      modalPlansOrto: false,
      modalPlansSLZ:false,
      modalOnPlansOrtoVip: false,
      modalOpenUF:true,

      plansView: 1,
      formCrm7Open: false,
      salesManName: '',
      selectSalesMan: false,
      estado : 0

    }


    this.styles = {
      avatar: {
        div: {
          padding: '30px 0 20px 30px',
          backgroundColor: '#ffffff',
          height: 45,
          boxSizing: 'unset'
        },
        icon: {
          float: 'left',
          display: 'block',
          marginRight: 15,
          boxShadow: '0px 0px 0px 8px rgba(0,0,0,0.15)'
        }
      }
    };

  }

 /* IMPLEMENTAÇÃO DA SEPARAÇÃO DOS PLANOS POR ESTADO*/
  selecionaEstado(uf=null) {

    let state = this.state;
    if (uf != null)
      state.estado = parseInt(uf);
    else
      state.estado = parseInt(document.getElementById('i_select_states').value);
   state.modalOpenUF = false;

   localStorage.setItem('id_uf', state.estado);
   this.setState(state);
  }
  // Método refeito para tratar cache do vendedor 
  componentDidMount() {
    this.setState({
      listOfStates: [
        { Id: 15, Sigla: 'Pernambuco' },
        { Id: 14, Sigla: 'Paraíba' },
        { Id: 9, Sigla: 'Maranhão' },
        { Id: 19, Sigla: 'Rio Grande do Norte' }
      ]
    });

    var linkSite = window.location.href.split(urlBase.client);
    // Remove query params e barras extras para pegar apenas o slug limpo
    var routeParam = (linkSite[1] || '').split('?')[0].replace(/^\/+|\/+$/g, '');
    var self = this;

    // Se o link do vendedor trouxer o plano (ex.: /joao?plano=planodentalvip),
    // o cliente cai direto no formulário desse plano em vez de voltar pra home.
    // Só slugs que o formulário (/acessar) já conhece; qualquer outro valor é ignorado.
    var planosPermitidos = [
      'planodentalvip', 'dental-vvip',
      'planodentalorto', 'dental-ortomax',
      'planodentaldigital', 'dental-digital',
      'planodentalsuper', 'dental-super'
    ];
    var planoMatch = window.location.search.match(/[?&]plano=([^&]+)/);
    var planoParam = planoMatch ? decodeURIComponent(planoMatch[1]).toLowerCase() : '';
    if (planosPermitidos.indexOf(planoParam) === -1) {
      planoParam = '';
    }

    // Função para limpar o cache antigo
    var clearSalesmanCache = function () {
      localStorage.removeItem('dental_v_i');
      localStorage.removeItem('dental_v_name');
      localStorage.removeItem('dental_v_ps');
    };

    // Função centralizada para salvar e forçar a atualização da UI
    var saveSalesmanData = function (salesman, shouldRedirect) {
      if (!salesman) return;

      var userName = (salesman.user && salesman.user.name) ? salesman.user.name : '';

      localStorage.setItem('dental_v_i', salesman.id || '');
      localStorage.setItem('dental_v_name', userName);

      var hasPagSeguro = Boolean(salesman.pagSeguroToken && salesman.pagSeguroEmail);
      localStorage.setItem('dental_v_ps', hasPagSeguro);

      // Atualiza imediatamente a interface do componente React
      self.update_salesMan();

      var targetUrl = "https://vendas.planodentalcenter.com.br/";
      if (shouldRedirect) {
        if (planoParam) {
          // Vendedor já gravado no localStorage acima; vai direto pro formulário do plano.
          window.location.href = urlBase.client + 'acessar?plano=' + encodeURIComponent(planoParam);
        } else if (window.location.href !== targetUrl) {
          window.location.href = targetUrl;
        }
      }
    };

    // Função para buscar o vendedor padrão (fallback)
    var fetchFallbackSalesman = function () {
      clearSalesmanCache();
      var fallbackFilter = JSON.stringify({
        where: { linkSite: 'dental-center' },
        include: 'user'
      });

      axios.get(urlBase.loopBack + 'Salesmans?filter=' + encodeURIComponent(fallbackFilter))
        .then(function (fallbackRes) {
          if (fallbackRes.data && fallbackRes.data.length > 0) {
            saveSalesmanData(fallbackRes.data[0], false);
          }
        })
        .catch(function () {
          alert('Problema encontrado ao buscar dados do vendedor padrão.');
        });
    };

    // --- LÓGICA DE DECISÃO DE ROTA ---

    if (routeParam && routeParam !== 'foryouandyourfamily') {
      // 1. Sempre LIMPA o vendedor antigo antes de buscar o novo
      clearSalesmanCache();

      var filter = JSON.stringify({
        where: { linkSite: routeParam },
        include: 'user'
      });

      axios.get(urlBase.loopBack + 'Salesmans?filter=' + encodeURIComponent(filter))
        .then(function (result) {
          var data = result.data;
          if (data && data.length > 0 && data[0].user && data[0].user.active) {
            // Vendedor encontrado e ativo
            saveSalesmanData(data[0], true);
          } else {
            // Vendedor não encontrado ou inativo -> Força fallback
            fetchFallbackSalesman();
          }
        })
        .catch(function () {
          fetchFallbackSalesman();
        });

    } else if (routeParam === 'foryouandyourfamily') {
      clearSalesmanCache();
      var admFilter = JSON.stringify({
        where: { linkSite: 'adm-jp' },
        include: 'user'
      });

      axios.get(urlBase.loopBack + 'Salesmans?filter=' + encodeURIComponent(admFilter))
        .then(function (result) {
          if (result.data && result.data.length > 0) {
            saveSalesmanData(result.data[0], false);
          }
        })
        .catch(function () {
          alert('Problema encontrado ao buscar dados do vendedor');
        });

    } else {
      // 2. Se a página foi acessada sem parâmetro na URL (ex: home ou após o redirect),
      // garante que se não houver vendedor no localStorage, carrega o vendedor padrão
      if (!localStorage.getItem('dental_v_i')) {
        fetchFallbackSalesman();
      }
    }
  }

  update_salesMan() {

    if (localStorage.getItem('dental_v_name') == null) {
      this.state.selectSalesMan = false;
    } else {
      this.state.selectSalesMan = true;
      this.state.salesManName = localStorage.getItem('dental_v_name');
    }
    this.setState(this.state);
  }

  next_plans() {
    let state = this.state;
    if ( this.state.estado == 19 ) {
          if (this.state.plansView < 3)
          state.plansView++;
        else if (this.state.plansView == 3)
          state.plansView = 1;
    } else {
      if (this.state.plansView < 4)
      state.plansView++;
    else if (this.state.plansView == 4)
      state.plansView = 1;
    }
    this.setState(state);

  }

  back_plans() {
    let state = this.state;
    if (this.state.plansView > 1)
      state.plansView--;
    else if (this.state.plansView == 1) {
      if ( this.state.estado == 19 )
          state.plansView = 3;
      else   
          state.plansView = 4;
    }

    this.setState(state);
  }

  modalOnPlansClinico() {
    let state = this.state;
    state.modalPlansClinico = true;
    this.setState(state);
  }
  modalOffPlansClinico() {
    let state = this.state;
    state.modalPlansClinico = false;
    this.setState(state);
  }  
  modalOnPlansClinicoSLZ() {
    let state = this.state;
    state.modalPlansClinicoSLZ = true;
    this.setState(state);
  }  
  modalOffPlansClinicoSLZ() {
    let state = this.state;
    state.modalPlansClinicoSLZ = false;
    this.setState(state);
  }

  modalOnPlansDigital() {
    let state = this.state;
    state.modalPlansDigital = true;
    this.setState(state);
  }

  modalOffPlansDigital() {
    let state = this.state;
    state.modalPlansDigital = false;
    this.setState(state);
  }

  modalOnPlansVip() {
    let state = this.state;
    state.modalPlansVip = true;
    this.setState(state);
  }

  modalOffPlansVip() {
    let state = this.state;
    state.modalPlansVip = false;
    this.setState(state);
  }

  modalOnPlansOrto() {
    let state = this.state;
    state.modalPlansOrto = true;
    this.setState(state);
  }

  modalOffPlansOrto() {
    let state = this.state;
    state.modalPlansOrto = false;
    this.setState(state);
  }

  modalOnPlansSLZ() {
    let state = this.state;
    state.modalPlansSLZ = true;
    this.setState(state);
  }
  /** NOVO */
  modalOnPlansOrtoVip() {
    let state = this.state;
    state.modalOnPlansOrtoVip = true;
    this.setState(state);
  }
  modalOffPlansOrtoVip() {
    let state = this.state;
    state.modalOnPlansOrtoVip = false;
    this.setState(state);
  }  
  modalOffPlansSLZ() {
    let state = this.state;
    state.modalPlansSLZ = false;
    this.setState(state);
  }


  onCloseModalUF(){
    let state = this.state;
    state.modalOpenUF = false;
    this.setState(state);
  }
  setValuePlan(id, payment, type, showCardFlags) {
    localStorage.setItem("dental_plan", id);
    localStorage.setItem("payment_plan", payment);
    localStorage.setItem("type_plan", type);
    localStorage.setItem("show_card_flags", showCardFlags);

    window.location.href = urlBase.client + 'formmakeyourplan';
  }

  formCrm7Open() {
    let state = this.state;
    state.formCrm7Open = true;
    this.setState(state);
  }

  formCrm7Close() {
    let state = this.state;
    state.formCrm7Open = false;
    this.setState(state);
  }


  render() {
    return(<div></div>);

  }
}

export default PlansNew;



/** WEBPACK FOOTER **
 ** ./src/components/ForYouAndYourFamilyNew/PlansNew.js
 **/